import React, { useState, useEffect } from 'react';
import styles from './style.module.scss';
import { Col, Row, Button, Form, Input, Select, Upload, message, Table, Card } from 'antd';
import { UploadOutlined, PlusOutlined } from '@ant-design/icons';
import { api } from '../../services/apiClient';
import { useAuth } from '../../contexts/AuthContext';

const { Option } = Select;

const baseURL = 'https://credx-bucket.s3.amazonaws.com/';

const Contatos = () => {
  const { user } = useAuth();

  const [contatos, setContatos] = useState([]);


  // Fetch contatos para a tabela
  const fetchContatos = async () => {
    try {
      const response = await api.get('/contatos');
      setContatos(response.data);
    } catch (error) {
      console.error(error);
      message.error('Erro ao buscar contatos');
    }
  };

  useEffect(() => {
    fetchContatos();
  }, []);
  const contatoColumns = [
    { title: 'Nome Completo', dataIndex: 'nomeCompleto', key: 'nomeCompleto' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Telefone', dataIndex: 'telefone', key: 'telefone' },
    { title: 'Assunto', dataIndex: 'assunto', key: 'assunto' },
    { title: 'Mensagem', dataIndex: 'mensagem', key: 'mensagem' },
  ];

  return (
    <div className={styles.container}>
      
      <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
        <Col span={24}>
          <h2>Contatos</h2>
          <Table dataSource={contatos} columns={contatoColumns} rowKey='id' style={{ width: '100%' }} />
        </Col>
      </Row>
    </div>
  );
};

export default Contatos;
